import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-question-gray.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "filter-container"
}
const _hoisted_3 = { class: "build-budget-wr" }
const _hoisted_4 = {
  class: "dropdown-button input-dropdown option-label price",
  type: "button"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-recommended" }
const _hoisted_7 = {
  key: 0,
  class: "price-recommended"
}
const _hoisted_8 = {
  key: 2,
  class: "tooltip"
}
const _hoisted_9 = {
  key: 1,
  class: "line"
}
const _hoisted_10 = { class: "bedrooms-wr" }
const _hoisted_11 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "bathrooms-wr" }
const _hoisted_14 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "storeys-wr" }
const _hoisted_17 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-build" }, "Build Budget", -1)),
            _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_4, _toDisplayString($setup.filtersGlobal.budget), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.optionsBuildBudgetPrice, (buildBudgetPrice) => {
                    return _createElementVNode("li", {
                      key: buildBudgetPrice,
                      onClick: ($event: any) => ($setup.selectBudget(buildBudgetPrice)),
                      class: _normalizeClass({ 'dropdown__item-active': buildBudgetPrice === $setup.filtersGlobal.budget })
                    }, _toDisplayString(buildBudgetPrice), 11, _hoisted_5)
                  }), 64))
                ])
              ]),
              _: 1
            })
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["recommended-build-budget-wr", { spacing: $setup.props.houseDetailsView, 'box-mobile': $setup.props.isDesignModal }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(!$setup.props.houseDetailsView ? "Recommended Build Budget" : "Need help calculating your budget?"), 1),
                  (!$setup.props.houseDetailsView)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "icon-question",
                        src: _imports_0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openHelpModal()))
                      }))
                    : _createCommentVNode("", true)
                ]),
                (!$setup.props.houseDetailsView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "$" + _toDisplayString($setup.lowerBudgetLimit) + " - $" + _toDisplayString($setup.upperBudgetLimit), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "button default primary recommended",
                      onClick: $setup.onHowMuchYouCouldBorrow
                    }, "Find out how much you could borrow")),
                (!$setup.props.houseDetailsView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "This recommendation is calculated as a percentage of your overall budget above."))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-bedrooms" }, "Bedrooms", -1)),
            _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_11, _toDisplayString($setup.filtersGlobal.bedrooms), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsBedrooms, (bedrooms) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: bedrooms,
                      onClick: ($event: any) => ($setup.selectBedrooms(bedrooms)),
                      class: _normalizeClass({ 'dropdown__item-active': bedrooms === $setup.filtersGlobal.bedrooms })
                    }, _toDisplayString(bedrooms), 11, _hoisted_12))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-bathrooms" }, "Bathrooms", -1)),
            _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_14, _toDisplayString($setup.filtersGlobal.bathrooms), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsBathrooms, (bathrooms) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: bathrooms,
                      onClick: ($event: any) => ($setup.selectBathrooms(bathrooms)),
                      class: _normalizeClass({ 'dropdown__item-active': bathrooms === $setup.filtersGlobal.bathrooms })
                    }, _toDisplayString(bathrooms), 11, _hoisted_15))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-storeys" }, "Storeys", -1)),
            _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_17, _toDisplayString($setup.filtersGlobal.storeys), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsStoreys, (storey) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: storey,
                      onClick: ($event: any) => ($setup.selectStoreys(storey)),
                      class: _normalizeClass({ 'dropdown__item-active': storey === $setup.filtersGlobal.storeys })
                    }, _toDisplayString(storey), 11, _hoisted_18))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}